export const getQriServiceUrl = (useNewStagingDomain: boolean): string =>
  (!useNewStagingDomain && process.env.REACT_APP_LEGACY_QRI_SERVICE_URL) ||
  process.env.REACT_APP_QRI_SERVICE_URL ||
  '';

export const getRecognisedQriServiceUrls = (): string[] =>
  [
    process.env.REACT_APP_QRI_SERVICE_URL,
    process.env.REACT_APP_LEGACY_QRI_SERVICE_URL,
  ].filter((url): url is string => Boolean(url));

export const isQriUrl = (url: string): boolean =>
  getRecognisedQriServiceUrls().some((qriServiceUrl) =>
    url.startsWith(qriServiceUrl),
  );
